/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { WatchListData, WatchListSearchResult } from "./types";

export const getColumns = ({
  onDelete,
}: {
  onDelete: (row: WatchListData) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
  },
  {
    field: "description",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "watchlistTypeId",
    headerName: "Type ID",
    flex: 0.5,
  },
  {
    field: "entityType",
    headerName: "Entity Type",
    flex: 1,
    valueGetter: (value: any) => value?.description || "",
  },
  {
    field: "iBaseId",
    headerName: "iBase ID",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",

    align: "right",
    getActions: ({ row }: { row: WatchListData }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

export const getEntityColumns = ({
  onAdd,
}: {
  onAdd: (row: WatchListSearchResult) => void;
}): GridColDef[] => [
  {
    field: "iBaseId",
    headerName: "iBase ID",
    flex: 1,
  },
  {
    field: "description",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "entityType",
    headerName: "Entity Type",
    flex: 1,
    valueGetter: (value: any) => value?.description || "",
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 100,
    align: "right",
    getActions: ({ row }: { row: WatchListSearchResult }) => [
      <Button
        key="add"
        onClick={(e: any) => {
          e.stopPropagation();
          onAdd(row);
        }}
      >
        <AddIcon fontSize="small" />
      </Button>,
    ],
  },
];

export const pageTitle = "Watch List";
